define([
    'text!product-detail/component/size-image-animate.html',
    'lodash',
    'inView',
    'common/utils',

    'css!product-detail/component/size-image-animate.css'
], function(
    tpl,
    _,
    inView,
    Utils
){
    return {
        template: tpl,
        props: {
            images: {
                type: Array
            },
            bgColor: {
                type: String
            },
            bgColorDown: {
                type: String
            }
        },
        data: function(){
            return {
                bgWidth: '50%',
                className: 'js-size-image-animate',
                bgImageKey: 'image1',
                duration: 1000,
                imageOptions: {
                    usePng: true
                }
            };
        },
        computed: {
            image1: function(){
                return _.first(this.images) || '';
            },
            image2: function(){
                return _.last(this.images) || '';
            },
            bgImage: function(){
                return this[this.bgImageKey];
            },
            imageStyle: function(){
                var image = Utils.genFnjiImageUrl(this[this.bgImageKey], this.imageOptions);
                if (!image) return null;
                return {
                    backgroundImage: 'url('+image+')'
                };
            }
        },
        mounted: function(){
            var _this = this;
            var task = null;
            var delay = 500;
            inView('.'+this.className).on('enter', function(){
                task = setTimeout(function(){
                    _this.bgWidth = '100%';
                    task = setTimeout(function(){
                        _this.bgImageKey = 'image2';
                        task = null;
                    }, _this.duration);
                }, delay);
            }).on('exit', function(){
                if (task){
                    clearTimeout(task);
                    task = null;
                }
                _this.bgWidth = '50%';
                _this.bgImageKey = 'image1';
            });
        }
    };
});


//////////////////
// WEBPACK FOOTER
// ./product-detail/component/size-image-animate.js
// module id = 246
// module chunks = 0